import { ICON_TYPES } from './iconTypes';

export default {
	notificationCircle: {
		name: 'notifications-circle',
		type: ICON_TYPES.ionicon,
		text: 'On',
	},
	notificationCircleOff: {
		name: 'notifications-off-circle',
		type: ICON_TYPES.ionicon,
		text: 'Off',
	},
};